import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import { useDispatch } from "react-redux";

import { useProfile } from "../Components/Hooks/UserHooks";

import { logoutUser } from "../slices/auth/login/thunk";

const AuthProtected = (props : any) =>{
  const dispatch : any = useDispatch();
  const { userProfile, loading, token, role } = useProfile();
  
  useEffect(() => {

    if (userProfile && !loading && token && role) {
      setAuthorization(token);
    } else if (!userProfile && loading && !token) {
      dispatch(logoutUser());
    }
  }, [token, userProfile, loading, role, dispatch]);

  /*
    Navigate is un-auth access protected routes via url
  */

  if (!userProfile && loading && !token && !role) {
    return (
      <Navigate to={{ pathname: "/login"}} />
    );
  }

  if(props?.permission && props?.permission?.length > 0 && !props?.permission.includes(role)){
    return (
      <Navigate to={{ pathname: "/"}} />
    );
  }

  return <>{props.children}</>;
};


export default AuthProtected;